export function Table() {
  return (
    <svg
      width="670"
      height="440"
      viewBox="0 0 670 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4336_40967)">
        <rect
          y="0.463867"
          width="670"
          height="439"
          rx="20.1997"
          fill="#FFFDF9"
        />
        <g clipPath="url(#clip1_4336_40967)">
          <mask id="path-3-inside-1_4336_40967" fill="white">
            <path d="M0 56.4639H711V115.508H0V56.4639Z" />
          </mask>
          <mask id="path-5-inside-2_4336_40967" fill="white">
            <path d="M0 56.4639H72.1651V115.508H0V56.4639Z" />
          </mask>
          <path d="M0 56.4639H72.1651V115.508H0V56.4639Z" fill="#FFFDF9" />
          <path
            d="M72.1651 56.4639H71.1651V115.508H72.1651H73.1651V56.4639H72.1651Z"
            fill="#D7D3C9"
            mask="url(#path-5-inside-2_4336_40967)"
          />
          <rect
            x="26.2422"
            y="76.1475"
            width="19.6814"
            height="19.6814"
            fill="#FFFDF9"
          />
          <path
            d="M23.7832 98.2883H48.3849V73.6865H23.7832V98.2883ZM26.5167 76.4201H45.6514V95.5547H26.5167V76.4201Z"
            fill="#D7D3C9"
          />
          <mask id="path-9-inside-3_4336_40967" fill="white">
            <path d="M72.166 56.4639H236.178V115.508H72.166V56.4639Z" />
          </mask>
          <path
            d="M72.166 56.4639H236.178V115.508H72.166V56.4639Z"
            fill="#FFFDF9"
          />
          <path
            d="M236.178 56.4639H235.178V115.508H236.178H237.178V56.4639H236.178Z"
            fill="#D7D3C9"
            mask="url(#path-9-inside-3_4336_40967)"
          />
          <rect
            x="91.8477"
            y="76.145"
            width="72.3156"
            height="19.6814"
            rx="9.8407"
            fill="#ECE9DF"
          />
          <mask id="path-12-inside-4_4336_40967" fill="white">
            <path d="M236.176 56.4639H400.187V115.508H236.176V56.4639Z" />
          </mask>
          <path
            d="M236.176 56.4639H400.187V115.508H236.176V56.4639Z"
            fill="#FFFDF9"
          />
          <path
            d="M400.187 56.4639H399.187V115.508H400.187H401.187V56.4639H400.187Z"
            fill="#D7D3C9"
            mask="url(#path-12-inside-4_4336_40967)"
          />
          <rect
            x="255.857"
            y="76.145"
            width="86.624"
            height="19.6814"
            rx="9.8407"
            fill="#ECE9DF"
          />
          <mask id="path-15-inside-5_4336_40967" fill="white">
            <path d="M400.188 56.4639H564.199V115.508H400.188V56.4639Z" />
          </mask>
          <path
            d="M400.188 56.4639H564.199V115.508H400.188V56.4639Z"
            fill="#FFFDF9"
          />
          <path
            d="M564.199 56.4639H563.199V115.508H564.199H565.199V56.4639H564.199Z"
            fill="#D7D3C9"
            mask="url(#path-15-inside-5_4336_40967)"
          />
          <rect
            x="419.869"
            y="76.145"
            width="86.624"
            height="19.6814"
            rx="9.8407"
            fill="#ECE9DF"
          />
          <rect
            width="164.012"
            height="59.0442"
            transform="translate(564.199 56.4639)"
            fill="#FFFDF9"
          />
          <rect
            x="583.881"
            y="76.145"
            width="91.8465"
            height="19.6814"
            rx="9.8407"
            fill="#ECE9DF"
          />
        </g>
        <path
          d="M0 56.4639V57.4639H711V56.4639V55.4639H0V56.4639ZM711 115.508V114.508H0V115.508V116.508H711V115.508Z"
          fill="#D7D3C9"
          mask="url(#path-3-inside-1_4336_40967)"
        />
        <g clipPath="url(#clip2_4336_40967)">
          <mask id="path-19-inside-6_4336_40967" fill="white">
            <path d="M0 115.508H711V174.552H0V115.508Z" />
          </mask>
          <mask id="path-21-inside-7_4336_40967" fill="white">
            <path d="M0 115.508H72.1651V174.552H0V115.508Z" />
          </mask>
          <path d="M0 115.508H72.1651V174.552H0V115.508Z" fill="#FFFDF9" />
          <path
            d="M72.1651 115.508H71.1651V174.552H72.1651H73.1651V115.508H72.1651Z"
            fill="#D7D3C9"
            mask="url(#path-21-inside-7_4336_40967)"
          />
          <rect
            x="26.2422"
            y="135.192"
            width="19.6814"
            height="19.6814"
            fill="#FFFDF9"
          />
          <path
            d="M23.7832 157.333H48.3849V132.731H23.7832V157.333ZM26.5167 135.464H45.6514V154.599H26.5167V135.464Z"
            fill="#D7D3C9"
          />
          <mask id="path-25-inside-8_4336_40967" fill="white">
            <path d="M72.166 115.508H236.178V174.552H72.166V115.508Z" />
          </mask>
          <path
            d="M72.166 115.508H236.178V174.552H72.166V115.508Z"
            fill="#FFFDF9"
          />
          <path
            d="M236.178 115.508H235.178V174.552H236.178H237.178V115.508H236.178Z"
            fill="#D7D3C9"
            mask="url(#path-25-inside-8_4336_40967)"
          />
          <rect
            x="91.8477"
            y="135.189"
            width="116.273"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-28-inside-9_4336_40967" fill="white">
            <path d="M236.176 115.508H400.187V174.552H236.176V115.508Z" />
          </mask>
          <path
            d="M236.176 115.508H400.187V174.552H236.176V115.508Z"
            fill="#FFFDF9"
          />
          <path
            d="M400.187 115.508H399.187V174.552H400.187H401.187V115.508H400.187Z"
            fill="#D7D3C9"
            mask="url(#path-28-inside-9_4336_40967)"
          />
          <rect
            x="255.857"
            y="135.189"
            width="65.8898"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-31-inside-10_4336_40967" fill="white">
            <path d="M400.188 115.508H564.199V174.552H400.188V115.508Z" />
          </mask>
          <path
            d="M400.188 115.508H564.199V174.552H400.188V115.508Z"
            fill="#FFFDF9"
          />
          <path
            d="M564.199 115.508H563.199V174.552H564.199H565.199V115.508H564.199Z"
            fill="#D7D3C9"
            mask="url(#path-31-inside-10_4336_40967)"
          />
          <rect
            x="419.869"
            y="135.189"
            width="65.8898"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <rect
            width="164.012"
            height="59.0442"
            transform="translate(564.199 115.508)"
            fill="#FFFDF9"
          />
          <rect
            x="583.881"
            y="135.189"
            width="91.8465"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M711 174.552V173.552H0V174.552V175.552H711V174.552Z"
          fill="#D7D3C9"
          mask="url(#path-19-inside-6_4336_40967)"
        />
        <g clipPath="url(#clip3_4336_40967)">
          <mask id="path-35-inside-11_4336_40967" fill="white">
            <path d="M0 174.552H711V233.596H0V174.552Z" />
          </mask>
          <mask id="path-37-inside-12_4336_40967" fill="white">
            <path d="M0 174.552H72.1651V233.596H0V174.552Z" />
          </mask>
          <path d="M0 174.552H72.1651V233.596H0V174.552Z" fill="#FFFDF9" />
          <path
            d="M72.1651 174.552H71.1651V233.596H72.1651H73.1651V174.552H72.1651Z"
            fill="#D7D3C9"
            mask="url(#path-37-inside-12_4336_40967)"
          />
          <rect
            x="26.2422"
            y="194.236"
            width="19.6814"
            height="19.6814"
            fill="#FFFDF9"
          />
          <path
            d="M23.7832 216.377H48.3849V191.775H23.7832V216.377ZM26.5167 194.509H45.6514V213.644H26.5167V194.509Z"
            fill="#D7D3C9"
          />
          <mask id="path-41-inside-13_4336_40967" fill="white">
            <path d="M72.166 174.552H236.178V233.596H72.166V174.552Z" />
          </mask>
          <path
            d="M72.166 174.552H236.178V233.596H72.166V174.552Z"
            fill="#FFFDF9"
          />
          <path
            d="M236.178 174.552H235.178V233.596H236.178H237.178V174.552H236.178Z"
            fill="#D7D3C9"
            mask="url(#path-41-inside-13_4336_40967)"
          />
          <rect
            x="91.8477"
            y="194.233"
            width="116.273"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-44-inside-14_4336_40967" fill="white">
            <path d="M236.176 174.552H400.187V233.596H236.176V174.552Z" />
          </mask>
          <path
            d="M236.176 174.552H400.187V233.596H236.176V174.552Z"
            fill="#FFFDF9"
          />
          <path
            d="M400.187 174.552H399.187V233.596H400.187H401.187V174.552H400.187Z"
            fill="#D7D3C9"
            mask="url(#path-44-inside-14_4336_40967)"
          />
          <rect
            x="255.857"
            y="194.233"
            width="65.8898"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-47-inside-15_4336_40967" fill="white">
            <path d="M400.188 174.552H564.199V233.596H400.188V174.552Z" />
          </mask>
          <path
            d="M400.188 174.552H564.199V233.596H400.188V174.552Z"
            fill="#FFFDF9"
          />
          <path
            d="M564.199 174.552H563.199V233.596H564.199H565.199V174.552H564.199Z"
            fill="#D7D3C9"
            mask="url(#path-47-inside-15_4336_40967)"
          />
          <rect
            x="419.869"
            y="194.233"
            width="65.8898"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <rect
            width="164.012"
            height="59.0442"
            transform="translate(564.199 174.552)"
            fill="#FFFDF9"
          />
          <rect
            x="583.881"
            y="194.233"
            width="91.8465"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M711 233.596V232.596H0V233.596V234.596H711V233.596Z"
          fill="#D7D3C9"
          mask="url(#path-35-inside-11_4336_40967)"
        />
        <g clipPath="url(#clip4_4336_40967)">
          <mask id="path-51-inside-16_4336_40967" fill="white">
            <path d="M0 233.596H711V292.64H0V233.596Z" />
          </mask>
          <mask id="path-53-inside-17_4336_40967" fill="white">
            <path d="M0 233.596H72.1651V292.64H0V233.596Z" />
          </mask>
          <path d="M0 233.596H72.1651V292.64H0V233.596Z" fill="#FFFDF9" />
          <path
            d="M72.1651 233.596H71.1651V292.64H72.1651H73.1651V233.596H72.1651Z"
            fill="#D7D3C9"
            mask="url(#path-53-inside-17_4336_40967)"
          />
          <rect
            x="26.2422"
            y="253.277"
            width="19.6814"
            height="19.6814"
            fill="#FFFDF9"
          />
          <path
            d="M23.7832 275.42H48.3849V250.818H23.7832V275.42ZM26.5167 253.551H45.6514V272.686H26.5167V253.551Z"
            fill="#D7D3C9"
          />
          <mask id="path-57-inside-18_4336_40967" fill="white">
            <path d="M72.166 233.596H236.178V292.64H72.166V233.596Z" />
          </mask>
          <path
            d="M72.166 233.596H236.178V292.64H72.166V233.596Z"
            fill="#FFFDF9"
          />
          <path
            d="M236.178 233.596H235.178V292.64H236.178H237.178V233.596H236.178Z"
            fill="#D7D3C9"
            mask="url(#path-57-inside-18_4336_40967)"
          />
          <rect
            x="91.8477"
            y="253.277"
            width="99.6864"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-60-inside-19_4336_40967" fill="white">
            <path d="M236.176 233.596H400.187V292.64H236.176V233.596Z" />
          </mask>
          <path
            d="M236.176 233.596H400.187V292.64H236.176V233.596Z"
            fill="#FFFDF9"
          />
          <path
            d="M400.187 233.596H399.187V292.64H400.187H401.187V233.596H400.187Z"
            fill="#D7D3C9"
            mask="url(#path-60-inside-19_4336_40967)"
          />
          <rect
            x="255.857"
            y="253.277"
            width="104.042"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-63-inside-20_4336_40967" fill="white">
            <path d="M400.188 233.596H564.199V292.64H400.188V233.596Z" />
          </mask>
          <path
            d="M400.188 233.596H564.199V292.64H400.188V233.596Z"
            fill="#FFFDF9"
          />
          <path
            d="M564.199 233.596H563.199V292.64H564.199H565.199V233.596H564.199Z"
            fill="#D7D3C9"
            mask="url(#path-63-inside-20_4336_40967)"
          />
          <rect
            x="419.869"
            y="253.277"
            width="104.042"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <rect
            width="164.012"
            height="59.0442"
            transform="translate(564.199 233.596)"
            fill="#FFFDF9"
          />
          <rect
            x="583.881"
            y="253.277"
            width="91.8465"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M711 292.64V291.64H0V292.64V293.64H711V292.64Z"
          fill="#D7D3C9"
          mask="url(#path-51-inside-16_4336_40967)"
        />
        <g clipPath="url(#clip5_4336_40967)">
          <mask id="path-67-inside-21_4336_40967" fill="white">
            <path d="M0 292.641H711V351.685H0V292.641Z" />
          </mask>
          <mask id="path-69-inside-22_4336_40967" fill="white">
            <path d="M0 292.641H72.1651V351.685H0V292.641Z" />
          </mask>
          <path d="M0 292.641H72.1651V351.685H0V292.641Z" fill="#FFFDF9" />
          <path
            d="M72.1651 292.641H71.1651V351.685H72.1651H73.1651V292.641H72.1651Z"
            fill="#D7D3C9"
            mask="url(#path-69-inside-22_4336_40967)"
          />
          <rect
            x="26.2422"
            y="312.321"
            width="19.6814"
            height="19.6814"
            fill="#FFFDF9"
          />
          <path
            d="M23.7832 334.464H48.3849V309.862H23.7832V334.464ZM26.5167 312.596H45.6514V331.731H26.5167V312.596Z"
            fill="#D7D3C9"
          />
          <mask id="path-73-inside-23_4336_40967" fill="white">
            <path d="M72.166 292.641H236.178V351.685H72.166V292.641Z" />
          </mask>
          <path
            d="M72.166 292.641H236.178V351.685H72.166V292.641Z"
            fill="#FFFDF9"
          />
          <path
            d="M236.178 292.641H235.178V351.685H236.178H237.178V292.641H236.178Z"
            fill="#D7D3C9"
            mask="url(#path-73-inside-23_4336_40967)"
          />
          <rect
            x="91.8477"
            y="312.322"
            width="99.6864"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-76-inside-24_4336_40967" fill="white">
            <path d="M236.176 292.641H400.187V351.685H236.176V292.641Z" />
          </mask>
          <path
            d="M236.176 292.641H400.187V351.685H236.176V292.641Z"
            fill="#FFFDF9"
          />
          <path
            d="M400.187 292.641H399.187V351.685H400.187H401.187V292.641H400.187Z"
            fill="#D7D3C9"
            mask="url(#path-76-inside-24_4336_40967)"
          />
          <rect
            x="255.857"
            y="312.322"
            width="104.042"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-79-inside-25_4336_40967" fill="white">
            <path d="M400.188 292.641H564.199V351.685H400.188V292.641Z" />
          </mask>
          <path
            d="M400.188 292.641H564.199V351.685H400.188V292.641Z"
            fill="#FFFDF9"
          />
          <path
            d="M564.199 292.641H563.199V351.685H564.199H565.199V292.641H564.199Z"
            fill="#D7D3C9"
            mask="url(#path-79-inside-25_4336_40967)"
          />
          <rect
            x="419.869"
            y="312.322"
            width="104.042"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <rect
            width="164.012"
            height="59.0442"
            transform="translate(564.199 292.641)"
            fill="#FFFDF9"
          />
          <rect
            x="583.881"
            y="312.322"
            width="91.8465"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M711 351.685V350.685H0V351.685V352.685H711V351.685Z"
          fill="#D7D3C9"
          mask="url(#path-67-inside-21_4336_40967)"
        />
        <g clipPath="url(#clip6_4336_40967)">
          <mask id="path-83-inside-26_4336_40967" fill="white">
            <path d="M0 351.685H711V410.729H0V351.685Z" />
          </mask>
          <mask id="path-85-inside-27_4336_40967" fill="white">
            <path d="M0 351.685H72.1651V410.729H0V351.685Z" />
          </mask>
          <path d="M0 351.685H72.1651V410.729H0V351.685Z" fill="#FFFDF9" />
          <path
            d="M72.1651 351.685H71.1651V410.729H72.1651H73.1651V351.685H72.1651Z"
            fill="#D7D3C9"
            mask="url(#path-85-inside-27_4336_40967)"
          />
          <rect
            x="26.2422"
            y="371.366"
            width="19.6814"
            height="19.6814"
            fill="#FFFDF9"
          />
          <path
            d="M23.7832 393.508H48.3849V368.907H23.7832V393.508ZM26.5167 371.64H45.6514V390.775H26.5167V371.64Z"
            fill="#D7D3C9"
          />
          <mask id="path-89-inside-28_4336_40967" fill="white">
            <path d="M72.166 351.685H236.178V410.729H72.166V351.685Z" />
          </mask>
          <path
            d="M72.166 351.685H236.178V410.729H72.166V351.685Z"
            fill="#FFFDF9"
          />
          <path
            d="M236.178 351.685H235.178V410.729H236.178H237.178V351.685H236.178Z"
            fill="#D7D3C9"
            mask="url(#path-89-inside-28_4336_40967)"
          />
          <rect
            x="91.8477"
            y="371.366"
            width="111.297"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-92-inside-29_4336_40967" fill="white">
            <path d="M236.176 351.685H400.187V410.729H236.176V351.685Z" />
          </mask>
          <path
            d="M236.176 351.685H400.187V410.729H236.176V351.685Z"
            fill="#FFFDF9"
          />
          <path
            d="M400.187 351.685H399.187V410.729H400.187H401.187V351.685H400.187Z"
            fill="#D7D3C9"
            mask="url(#path-92-inside-29_4336_40967)"
          />
          <rect
            x="255.857"
            y="371.366"
            width="71.6944"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-95-inside-30_4336_40967" fill="white">
            <path d="M400.188 351.685H564.199V410.729H400.188V351.685Z" />
          </mask>
          <path
            d="M400.188 351.685H564.199V410.729H400.188V351.685Z"
            fill="#FFFDF9"
          />
          <path
            d="M564.199 351.685H563.199V410.729H564.199H565.199V351.685H564.199Z"
            fill="#D7D3C9"
            mask="url(#path-95-inside-30_4336_40967)"
          />
          <rect
            x="419.869"
            y="371.366"
            width="104.042"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <rect
            width="164.012"
            height="59.0442"
            transform="translate(564.199 351.685)"
            fill="#FFFDF9"
          />
          <rect
            x="583.881"
            y="371.366"
            width="91.8465"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M711 410.729V409.729H0V410.729V411.729H711V410.729Z"
          fill="#D7D3C9"
          mask="url(#path-83-inside-26_4336_40967)"
        />
        <g clipPath="url(#clip7_4336_40967)">
          <mask id="path-99-inside-31_4336_40967" fill="white">
            <path d="M0 410.729H711V469.773H0V410.729Z" />
          </mask>
          <mask id="path-101-inside-32_4336_40967" fill="white">
            <path d="M0 410.729H72.1651V469.773H0V410.729Z" />
          </mask>
          <path d="M0 410.729H72.1651V469.773H0V410.729Z" fill="#FFFDF9" />
          <path
            d="M72.1651 410.729H71.1651V469.773H72.1651H73.1651V410.729H72.1651Z"
            fill="#D7D3C9"
            mask="url(#path-101-inside-32_4336_40967)"
          />
          <rect
            x="26.2422"
            y="430.411"
            width="19.6814"
            height="19.6814"
            fill="#FFFDF9"
          />
          <path
            d="M23.7832 452.553H48.3849V427.952H23.7832V452.553ZM26.5167 430.685H45.6514V449.82H26.5167V430.685Z"
            fill="#D7D3C9"
          />
          <mask id="path-105-inside-33_4336_40967" fill="white">
            <path d="M72.166 410.729H236.178V469.773H72.166V410.729Z" />
          </mask>
          <path
            d="M72.166 410.729H236.178V469.773H72.166V410.729Z"
            fill="#FFFDF9"
          />
          <path
            d="M236.178 410.729H235.178V469.773H236.178H237.178V410.729H236.178Z"
            fill="#D7D3C9"
            mask="url(#path-105-inside-33_4336_40967)"
          />
          <rect
            x="91.8477"
            y="430.41"
            width="83.9274"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-108-inside-34_4336_40967" fill="white">
            <path d="M236.176 410.729H400.187V469.773H236.176V410.729Z" />
          </mask>
          <path
            d="M236.176 410.729H400.187V469.773H236.176V410.729Z"
            fill="#FFFDF9"
          />
          <path
            d="M400.187 410.729H399.187V469.773H400.187H401.187V410.729H400.187Z"
            fill="#D7D3C9"
            mask="url(#path-108-inside-34_4336_40967)"
          />
          <rect
            x="255.857"
            y="430.41"
            width="75.0121"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <mask id="path-111-inside-35_4336_40967" fill="white">
            <path d="M400.188 410.729H564.199V469.773H400.188V410.729Z" />
          </mask>
          <path
            d="M400.188 410.729H564.199V469.773H400.188V410.729Z"
            fill="#FFFDF9"
          />
          <path
            d="M564.199 410.729H563.199V469.773H564.199H565.199V410.729H564.199Z"
            fill="#D7D3C9"
            mask="url(#path-111-inside-35_4336_40967)"
          />
          <rect
            x="419.869"
            y="430.41"
            width="75.0121"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
          <rect
            width="164.012"
            height="59.0442"
            transform="translate(564.199 410.729)"
            fill="#FFFDF9"
          />
          <rect
            x="583.881"
            y="430.41"
            width="91.8465"
            height="19.6814"
            rx="9.8407"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M711 469.773V468.773H0V469.773V470.773H711V469.773Z"
          fill="#D7D3C9"
          mask="url(#path-99-inside-31_4336_40967)"
        />
        <path
          d="M27.9355 21.3779H44.228V23.7054H27.9355V21.3779Z"
          fill="#D7D3C9"
        />
        <path
          d="M27.9355 26.0329H38.1183V28.3604H27.9355V26.0329Z"
          fill="#D7D3C9"
        />
        <path
          d="M38.1183 35.3429H27.9355V37.6704H38.1183V35.3429Z"
          fill="#D7D3C9"
        />
        <path
          d="M27.9355 30.6879H44.228V33.0154H27.9355V30.6879Z"
          fill="#D7D3C9"
        />
      </g>
      <rect
        x="0.5"
        y="0.963867"
        width="669"
        height="438"
        rx="19.6997"
        stroke="#B5B2AA"
      />
      <defs>
        <clipPath id="clip0_4336_40967">
          <rect
            y="0.463867"
            width="670"
            height="439"
            rx="20.1997"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_4336_40967">
          <path d="M0 56.4639H711V115.508H0V56.4639Z" fill="white" />
        </clipPath>
        <clipPath id="clip2_4336_40967">
          <path d="M0 115.508H711V174.552H0V115.508Z" fill="white" />
        </clipPath>
        <clipPath id="clip3_4336_40967">
          <path d="M0 174.552H711V233.596H0V174.552Z" fill="white" />
        </clipPath>
        <clipPath id="clip4_4336_40967">
          <path d="M0 233.596H711V292.64H0V233.596Z" fill="white" />
        </clipPath>
        <clipPath id="clip5_4336_40967">
          <path d="M0 292.641H711V351.685H0V292.641Z" fill="white" />
        </clipPath>
        <clipPath id="clip6_4336_40967">
          <path d="M0 351.685H711V410.729H0V351.685Z" fill="white" />
        </clipPath>
        <clipPath id="clip7_4336_40967">
          <path d="M0 410.729H711V469.773H0V410.729Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
